"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OFFER = exports.INCA = void 0;
var INCA = exports.INCA = 'inca';
var OFFER = exports.OFFER = 'offer';